import React from 'react';
import { useTable, useSortBy } from 'react-table';
import './VehicleTable.css'; // Ensure to include the new CSS file

const VehicleTable = ({ columns, data, onSort, sortConfig, expanded = false }) => {
    const tableInstance = useTable(
        { columns, data },
        useSortBy
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance;

    const formatNumber = (value) => {
        return typeof value === 'number' ? value.toFixed(1) : value;
    };

    const getClassNameForValue = (value, columnId) => {
        if (columnId.includes('Temp') && value > 140) {
            return 'highlight';
        }
        return '';
    };

    return (
        <div className="table-wrapper">
            <p className="sorting-hint">Click on any column header to sort</p>
            <table className={expanded ? "expanded-table" : "overview-table"} {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())} onClick={() => onSort(column.id)}>
                                    {column.render('Header')}
                                    <span className="sort-icon">
                                        {sortConfig.key === column.id
                                            ? sortConfig.direction === 'asc'
                                                ? ' ▲'
                                                : ' ▼'
                                            : ''}
                                    </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map(row => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => (
                                    <td {...cell.getCellProps()} className={getClassNameForValue(cell.value, cell.column.id)}>
                                        {formatNumber(cell.value)}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default VehicleTable;
